import { useApplicationContext } from 'shared/utils/applicationContext';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsCianAuthorized } from '../../selectors/user';
import { selectActionUrl } from 'shared/selectors/landing';
import { setCianAuthorizedModalOpen } from 'shared/redux/landingSlice';

export const useCianAuthorized = () => {
  const dispatch = useDispatch();
  const actionUrl = useSelector(selectActionUrl);
  const isCianAuthorized = useSelector(selectIsCianAuthorized);
  const { microfrontendsAPI, logger } = useApplicationContext();

  const cianAuthorizeAndRedirect = () => {
    if (isCianAuthorized && actionUrl) {
      window.open(actionUrl, '_self');
    } else if (microfrontendsAPI) {
      dispatch(setCianAuthorizedModalOpen(true));
      microfrontendsAPI.header.openAuthModal({ autoRefresh: false });
    } else {
      logger.error('Failed to open auth modal');
    }
  };

  return { cianAuthorizeAndRedirect };
};
